import React from 'react';
import { useTranslation } from 'react-i18next';

import { Col, Row } from 'antd/lib/grid';

import { Certificate, BadgeIcon, CourseIcon, Sofa, Diamond } from '@assets/index';

import FeatureCard from '../FeatureCard';
import './styles.less';
import { platform } from '@constants/config';

const FeatureCardSection = () => {
    const { t } = useTranslation();
    const features = [
        {
            id: 1,
            //@ts-ignore
            icon: platform.WITP ? BadgeIcon : Diamond,
            title: t('guestView.labelsAndTitles.CARD_TITLE1'),
            description: t('guestView.labelsAndTitles.CARD_DESCRIPTION1'),
        },
        {
            id: 2,
            //@ts-ignore
            icon: platform.WITP ? CourseIcon : Sofa,
            title: t('guestView.labelsAndTitles.CARD_TITLE2'),
            description: t('guestView.labelsAndTitles.CARD_DESCRIPTION2'),
        },
        {
            id: 3,
            icon: Certificate,
            title: t('guestView.labelsAndTitles.CARD_TITLE3'),
            description: t('guestView.labelsAndTitles.CARD_DESCRIPTION3'),
        }
    ]
    return (
        <div className="feature-card-section-container">
            <Row gutter={[98, 98]}>
                {features && features.map((feature) => {
                    const { id, icon, title, description } = feature;
                    return (
                        <Col key={id} lg={8} md={24} sm={24}>
                            <FeatureCard
                                id={id}
                                icon={icon}
                                title={title}
                                description={description}
                            />
                        </Col>

                    )
                })}
            </Row>
        </div>

    )
}

export default FeatureCardSection;
